import { createRequiredContext } from '@ha/utilities/React/RequiredContext';

import { ListingDetails } from '@kamernet/core/ApiClient/Kamernet';

export interface IListingDetails {
  listingDetails: ListingDetails;
  shareTargetURL: string;
}

export const ListingDetailsContext = createRequiredContext<IListingDetails>(
  'ListingDetailsContext',
);
